import React, { Component, Suspense } from "react";
import "./home-new.css";
import { connect } from "react-redux";
import { loadHomeNew } from "../../../../actions/dashboardActions";
import { toggleAddFeedsSection_D } from "../../../../actions/showDisplayModalAction";
import { getWidgetWallData } from "../../../../actions/wallDataAction";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { API_URL } from "../../../../actions/api";
import HttpClient from "../../../../actions/http-client";
import { LIVE_API } from "../../../../actions/api";
import { GET_RECENT_POST_DATA } from "../../../../reducers/keys";
import UpdateUserInfo from "./components/updateUserInfo";

const BookCall = React.lazy(() => import("./components/bookCall"));
const CreatedWalls = React.lazy(() => import("./components/createdWalls"));
const RecentPost = React.lazy(() => import("./components/recentPost"));
const SocialAction = React.lazy(() => import("./components/socialAction"));
const Website = React.lazy(() => import("./components/website"));
const LiveTrend = React.lazy(() => import("./components/liveTrend"));
const LeaderboardDashboard = React.lazy(() => import("./components/leaderboardDashboard"));

const ErrorMsg = React.lazy(() => import("./components/errorMsg"));


const WallDashboard = (props) => {
    const navigate = useNavigate();
    return <WD {...props} navigate={navigate} />
}
class WD extends Component {
    constructor(props) {
        super(props);
        this.state = { startDate: moment().subtract(30, 'days').startOf('day'), endDate: moment().endOf('day'), selectedWalls: 0, isFeeds: true };
    }

    unRecommendedList = [];
    RecomendedList = []

    componentWillMount() {
        const { startDate, endDate, selectedWalls } = this.state
        this.props.loadHome(1, startDate, endDate, selectedWalls);
    }

    filterDashbord = (start, end) => this.setState({ startDate: start, endDate: end }, () => this.props.loadHome(3, start, end, this.state.selectedWalls))
    WallFilterDashbord = (walls, isFeeds) => this.setState({ selectedWalls: walls, isFeeds }, () => this.props.loadHome(3, this.state.startDate, this.state.endDate, walls))

    nevigationRedirect = () => {
        const { navigate, upgradNow, getWidgetWallData, dashboardDisplayReducer, authenticated } = this.props;
        if (dashboardDisplayReducer.dashboarddata && dashboardDisplayReducer.dashboarddata.allWalllist && Object.keys(dashboardDisplayReducer.dashboarddata.allWalllist).length) {
            const wallId = dashboardDisplayReducer.dashboarddata.allWalllist[0].id;
            upgradNow(true)
            getWidgetWallData(authenticated.userData.user.id, wallId);
            navigate(`/wall/index/${wallId}`)
        }
    }


    isSentimentValid = (sentiment) => {
        return ((sentiment == null || sentiment == '' || sentiment == 'negative' || sentiment == 'postive' || sentiment == 'strongpos' || sentiment == 'neutral' || sentiment == 'strongneg' || sentiment == 0) && sentiment != '0.00');
    }

    getRecommemdation = () => {
        try {

            if (this.unRecommendedList.length > 0) {

                const { userData } = this.props.authenticated;

                new HttpClient().post(`${API_URL}/accounts/getsentimentAI`, {
                    postId: this.unRecommendedList[0].id,
                    table_name: userData.UserPlan.db_table
                }).then((response) => {

                    const { responseData } = response.data;
                    if (localStorage.getItem('wallId') != this.unRecommendedList[0].wallId) {
                        throw new Error('error')
                    }

                    if (responseData && Object.keys(responseData).length > 0) {

                        const { dashboardDisplayReducer } = this.props

                        const posts = dashboardDisplayReducer.recent_post_data.recentPosts;
                        const updatedList = posts.map(post => {
                            if (post.id == responseData.id) {
                                return { ...post, ...responseData }
                            }
                            return post;
                        });

                        this.props.updateList({ 'recentPosts': updatedList });
                    }


                    this.unRecommendedList.shift();
                    this.getRecommemdation()
                }).catch((error) => {
                    console.log("Errormessage:", error.message, error.code); // Error message
                })
            }
        } catch (error) {
            console.log("error---recommendation")
            this.unRecommendedList = [];
        }
    }


    getNotRecomendedList = (item, index) => {

        const { authenticated } = this.props;
        const email = authenticated.userData.user.emailId;
        const keywords = ['@taggbox', '@taggshop', '@tagembed'];
        //!['58','31'].some(data => authenticated.userData.UserPlan.planId.includes(data)) &&
        if (LIVE_API && authenticated.userData && Object.keys(authenticated.userData).length > 0 && authenticated.userData.UserRule.id != '133693' && authenticated.userData.user.trueSense && (!keywords.some(keyword => email.includes(keyword)) || authenticated.userData.UserRule.wasabi_upload == 1) && !authenticated.userInfo_updating) {

            if ([2, 3, 4, 5].includes(parseInt(item.type)) && (this.isSentimentValid(item.sentiment) || !item.recommendation)) {

                this.unRecommendedList.push({ id: item.id, wallId: localStorage.getItem('wallId') });
                if (this.unRecommendedList.length == 1) {
                    this.getRecommemdation();
                }
            } else if (item.type == 1 && this.isSentimentValid(item.sentiment)) {
                this.unRecommendedList.push({ id: item.id, wallId: localStorage.getItem('wallId') });
                if (this.unRecommendedList.length == 1) {
                    this.getRecommemdation();
                }
            }
        } else this.unRecommendedList = [];

    }

    componentWillUnmount() {
        this.unRecommendedList = [];
    }


    render() {
        const { authenticated, dashboardDisplayReducer } = this.props;
        const { dashboarddata, recent_post_data, socail_data, visitor_clicks_data, most_active_user_data, most_active_user_loader, dashboard_wall_loader, recent_post_loader, sentiment_live_loader, sentiment_live_trend_data, social_loader, visitor_clicks_loader, } = dashboardDisplayReducer;

        const userData = authenticated?.userData?.user

        return (

            <>

                <Suspense fallback={""}>
                    <ErrorMsg
                        {...socail_data}
                        key={socail_data}
                        loader={social_loader}
                    />
                </Suspense>

                <div id="dshsboard-page" className="home_screen_warp p-4 pb-0">
                    <div className="mx-w-1500">

                        <Suspense fallback={""}> <BookCall key={dashboard_wall_loader} loader={dashboard_wall_loader} {...this.state} {...authenticated} {...dashboarddata} /> </Suspense>
                        <Suspense fallback={""}> <CreatedWalls {...dashboarddata} {...authenticated} loader={dashboard_wall_loader} /> </Suspense>
                        {dashboard_wall_loader || dashboarddata && Object.keys(dashboarddata.allWalllist).length ? (
                            <>
                                <div className="row">
                                    <Suspense fallback={""}> <LeaderboardDashboard isDashboard={1} loader={most_active_user_loader} leaderBoard={most_active_user_data} nevigationRedirect={this.nevigationRedirect}  {...this.state} WallFilterDashbord={this.WallFilterDashbord} filterDashbord={this.filterDashbord} /> </Suspense>
                                    <Suspense fallback={""}> <LiveTrend leaderBoard={most_active_user_data} live_trend={sentiment_live_trend_data} loader={sentiment_live_loader} isUpgrade={userData?.trueSense} nevigationRedirect={this.nevigationRedirect} /> </Suspense>
                                </div>
                                <Suspense fallback={""}> <RecentPost key={recent_post_loader} {...recent_post_data} loader={recent_post_loader} isUpgrade={userData?.trueSense} getNotRecomendedList={this.getNotRecomendedList} /> </Suspense>
                                <div className="row">
                                    <Suspense fallback={""}> <SocialAction key={social_loader} {...socail_data} loader={social_loader} /> </Suspense>
                                    <Suspense fallback={""}> <Website key={visitor_clicks_loader} visitor={visitor_clicks_data} loader={visitor_clicks_loader} /> </Suspense>
                                </div>
                            </>
                        ) : null}
                        {!userData?.contact_no && userData?.loginCount == 2 && !localStorage.getItem('Isadmin') && localStorage.getItem('userInfoPopupClosed') !== 'true' && <UpdateUserInfo userData={userData} />}
                    </div>
                </div>
            </>

        );
    }
}

const contentStateToProps = (state) => {
    return {
        authenticated: state.authenticated,
        dashboardDisplayReducer: state.dashboardDisplayReducer,
    }
}

const contentDispatchToProps = (dispatch) => {
    return {
        loadHome: (props, startDate, endDate, walls) => dispatch(loadHomeNew(props, startDate, endDate, walls)),
        upgradNow: (props) => dispatch(toggleAddFeedsSection_D(props)),
        getWidgetWallData: (owner, wallId) => dispatch(getWidgetWallData(owner, wallId)),
        updateList: (list) => dispatch({ type: GET_RECENT_POST_DATA, payload: list })
    };
};

export default connect(
    contentStateToProps,
    contentDispatchToProps
)(WallDashboard);
